// How this visit to SHUWA started: where the visitor came from (a Google
// result, a shared link, straight here) and the page they arrived on. Sent
// with a booking so SHUWA can count which pages and search engines bring
// bookings. It stays in this tab until it is closed, names no one, and the
// API only keeps daily totals.
const KEY = "shuwa_arrival";

const SOURCES = [
  [/(^|\.)google\./, "google"],
  [/(^|\.)bing\.com$/, "bing"],
  [/(^|\.)(duckduckgo|yahoo|yandex|baidu)\./, "other-search"],
  [/(^|\.)(facebook|instagram|tiktok|linkedin|twitter|x|whatsapp|youtube)\.com$|^t\.co$|^wa\.me$/, "social"],
];

function sourceOf(referrer) {
  if (!referrer) return "direct";

  try {
    const host = new URL(referrer).hostname.toLowerCase();
    if (host === window.location.hostname) return "direct";

    return SOURCES.find(([pattern]) => pattern.test(host))?.[1] || "referral";
  } catch {
    return "direct";
  }
}

/** Notes how the visit started, once per tab. Call when the app loads. */
export function rememberArrival() {
  try {
    if (sessionStorage.getItem(KEY)) return;

    sessionStorage.setItem(
      KEY,
      JSON.stringify({ source: sourceOf(document.referrer), page: window.location.pathname })
    );
  } catch {
    // Storage is off (private mode): bookings are simply not attributed.
  }
}

/** { visit_source, landing_page } to send with a booking; empty when unknown. */
export function arrival() {
  try {
    const { source, page } = JSON.parse(sessionStorage.getItem(KEY) || "{}");

    return source && page ? { visit_source: source, landing_page: page } : {};
  } catch {
    return {};
  }
}
